import { Position } from '../../types'
import { useCallback, useContext } from 'react'
import { CutterContext } from '../contexts/CutterContext'

export function useGetPositionSeconds(): (position: Position) => number {
  const { sampleRate } = useContext(CutterContext).audioBuffer

  return useCallback((position: Position) => position / sampleRate, [sampleRate])
}
